<template>
    <div class="comment-thread">
        <BaseComment 
            :comment="comment"
            :deleted="!!comment.deleted"
        />
        <BaseComment
            v-for="reply in comment.childComments.slice(0, visibleReplies)"
            :key="reply.id"
            :comment="reply"
            :parent="comment"
            :deleted="!!reply.deleted"
            class="comment--reply"
        />
        <BaseButton
            v-if="comment.childComments.length > visibleReplies"
            class="base-button--outline comment-thread__load-more-replies"
            @click="visibleReplies += 30"
        >
            Load more replies
        </BaseButton>
    </div>
</template>

<script setup>
defineProps({
    comment: {
        type: Object,
        required: false,
        default: () => ({})
    }
});

const visibleReplies = ref(3);
</script>

<style lang="less">
.comment-thread__load-more-replies {
    margin-left: var(--spacing-lg);
    margin-bottom: var(--spacing-sm);
}
</style>